import {Vnode} from 'mithril';
import app from 'flarum/forum/app';
import {extend} from 'flarum/common/extend';
import User from 'flarum/common/models/User';
import AvatarEditor from 'flarum/forum/components/AvatarEditor';
import PostUser from 'flarum/forum/components/PostUser';
import UserCard from 'flarum/forum/components/UserCard';
import SettingsPage from 'flarum/forum/components/SettingsPage';
import Link from 'flarum/common/components/Link';
import DiscussionList from 'flarum/components/DiscussionList';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import ReplyComposer from 'flarum/forum/components/ReplyComposer';
import EditPostComposer from 'flarum/forum/components/EditPostComposer';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import PostStream from 'flarum/forum/components/PostStream';
import Notification from 'flarum/forum/components/Notification';
import FlagList from 'flarum/flags/components/FlagList';
import Search from 'flarum/forum/components/Search';

import addSidebarMenu from './addSidebarMenu';
import addShoppingCartMenu from './addShoppingCartMenu';
import addUserPage from './addUserPage';

import DecorationStore from "./model/DecorationStore";
import DecorationStorePurchase from "./model/DecorationStorePurchase";
import DecorationStoreEquipment from "./model/DecorationStoreEquipment";
import DecorationStoreIndexPage from './components/DecorationStoreIndexPage';
import DecorationStoreSubscriptionNotification from "./components/DecorationStoreSubscriptionNotification";
import mobileCheck from "./common/util/mobileCheck";

import NotificationGrid from "flarum/components/NotificationGrid";

const checkTime = 10;
const isMobileView = mobileCheck();

export * from './common/helpers';

function matchTag(tag: any): (node: Vnode) => boolean {
    return node => !!(node && node.tag && node.tag === tag);
}

function matchKey(key: string): (node: Vnode) => boolean {
    return node => !!(node && node.key && node.key === key);
}

function matchClass(className: string): (node: Vnode<any>) => boolean {
    return node => node && node.attrs && node.attrs.className && node.attrs.className.trim() === className;
}

function removeElement(id) {
    let elem = document.getElementById(id);
    if(elem){ elem.parentNode.removeChild(elem);}
}

function initFrameData(avatar,user,from){
	let frameUrl = user.attribute("decorationAvatarFrame");
	
	if(user===null){
		return null;
	}

	let frameWidth = $(avatar).outerWidth();
	let frameMarginLeft = $(avatar).css('margin-left');
	let frameMarginTop = $(avatar).css('margin-top');
	let frameMargin = $(avatar).css('margin');
	let frameLeft = $(avatar).css('left');
	let frameDisplay = $(avatar).css('display');
	let frameBorder = $(avatar).css('borderLeftWidth');
	let containerDisplay = null;

	const container = document.createElement("div");
	const frame = document.createElement("img");
	const avatarType = $(avatar)[0].tagName;
	let frameScale = frameBorder==="4px"?1.48:1.6;
	let frameIndex = -1;

	if(isMobileView){
		containerDisplay = "inline";
	}

	if(from==="post"){
		frameLeft = frameLeft==="auto"?"0px":frameLeft;
	}else if(from==="userCard"){
	}else if(from==="avatarEditor"){
	}else if(from==="discussionList"){
	}else if(from==="discussionComposer"){
	}else if(from==="headerSecondary"){
		containerDisplay = "inline";
	}else if(from==="postStreamReply"){
		frameIndex = 10;
	}else if(from==="notification"){
		frameMarginLeft = "13px";

		if(avatarType==="IMG"){
			frameMarginTop = "3px";
		}else{
			frameMarginTop = "5px";
		}
	}

	frame.style.pointerEvent = "none";
	frame.style.position = "absolute";

	if(frameIndex!==-1){ frame.style.zIndex = frameIndex;}

	frame.style.transform = "scale("+frameScale+","+frameScale+")";
	frame.style.width = frameWidth+"px";
	frame.style.marginLeft = frameMarginLeft;
	frame.style.marginTop = frameMarginTop;
	frame.style.margin = frameMargin;
	frame.style.left = frameLeft;
	frame.src = frameUrl===null?"":frameUrl;
	frame.className = "decorationAvatarFrameImageSource";

	if(frameDisplay!=="flex"){
		frame.style.display = frameDisplay;
	}

	container.style.position = "absolute";

	if(from==="notification"){
		container.style.position = "absolute";
	}

	if(containerDisplay){
		container.style.display = containerDisplay;
	}

	container.className = "decorationAvatarFrame_"+from;
	container.frameUrl = frameUrl;
	container.from = from;
	container.id = "avatarFrame"+from+"_"+user.id();
	container.appendChild(frame);

	container.setAttribute("username", user.username());

	return container;
}

function insertAvatarFrame(element,user,from){
	if(from==="postStreamReply"){
		if(element.dom.frameID){
			delete element.dom.init;
			removeElement(element.dom.frameID);
		}
	}

	if(element.dom.init===undefined){
		element.dom.init = true;

		if(user){
			let avatarEle = $(element.dom).find(".Avatar");
			let usernameEle = $(element.dom).find(".username");

			if(avatarEle.length>0){
				let frame = initFrameData(avatarEle[0],user,from);

				if(frame){
					element.dom.frameID = frame.id;
					avatarEle[0].parentNode.prepend(frame);
				}
			}

			if(usernameEle.length>0){
				let userName = usernameEle.text();

				if(userName===user.username()){
					let usernameColorClass = user.attribute("decorationUsernameColor");
					$(usernameEle[0]).addClass(usernameColorClass);
				}else{
					findUserInStore(userName,function(userStoreData){
						let usernameColorClass = userStoreData.attribute("decorationUsernameColor");

						if(usernameColorClass!==""){
							$(usernameEle[0]).addClass(usernameColorClass);
						}
					});
				}
			}
		}
	}
}

function attachUsernameColor(vdom: Vnode<any>, user: User, from): void {
	let task = setInterval(function(){
		if(vdom.dom){
			clearInterval(task);

			let usernameColorClass = user.attribute("decorationUsernameColor");

			if(from==="search"){
				$(vdom.dom).removeClass().addClass("username");
				delete vdom.dom.initUsername;
			}

			if(vdom.dom.initUsername===undefined){
				if(usernameColorClass===""){

				}else{
					if($(vdom.dom).hasClass(usernameColorClass)===false){
						vdom.dom.initUsername = true;
						$(vdom.dom).addClass(usernameColorClass);
					}
				}
			}
		}
	},checkTime);
}

function attachAvatarFrame(vdom: Vnode<any>, user: User, from): void {
	let task = setInterval(function(){
		if(vdom.dom){
			clearInterval(task);

			if(!user){ return; }

			if(from==="search"){
				let parentNode = $(vdom.dom).parent().find(".decorationAvatarFrame_search");
				let parentNodeUsername = parentNode.attr('username');

				if(parentNodeUsername && parentNodeUsername!==user.username()){
					parentNode.remove();
					delete vdom.dom.initAvatar;
				}
			}

			if(vdom.dom.initAvatar===undefined){
				vdom.dom.initAvatar = true;
				let frame = initFrameData(vdom.dom,user,from);

				if(frame){
					if(from==="userCard" || from==="avatarEditor"){
						if(frame.frameUrl!==""){
							$(vdom.dom).parent().find(".Avatar").css("background-clip","padding-box");
							$(vdom.dom).parent().find(".Avatar").css("border","4px solid rgba(0,0,0,0)");
							$(vdom.dom).parent().find(".Avatar").css("box-shadow","none");
						}
					}

					if(from==="post"){
				        $(vdom.dom).wrap(function() {
				          return "<div style='position:relative;display:inline-block;'></div>";
				        });

						if(isMobileView){
							vdom.dom.before(frame);
						}else{
							vdom.dom.after(frame);
						}
					}else if(from==="notification"){
						vdom.dom.before(frame);
					}else{
						vdom.dom.parentNode.prepend(frame);
					}

					if(from==="discussionComposer"){
						attachComposerFullScreenEvent(from);
					}
				}
			}
		}
	},checkTime);
}

function attachProfileBackground(vdom: Vnode<any>, user: User, from){
	let task = setInterval(function(){
		if(vdom.dom){
			clearInterval(task);

			if(vdom.dom.initProfileBackground===undefined){
				vdom.dom.initProfileBackground = true;
				
				let imageUrl = user.attribute("decorationProfileBackground");
				const routeName = app.current.data.routeName;

				$("body").css("--decoration-profileBackground","url("+imageUrl+")");
				$(vdom.dom).addClass("UserCardDecorationProfileBackground");
			}
		}
	},checkTime);
}

function findUserInStore(username,callback){
	let userStore = app.store.data.users;

    for(let userID in userStore){
    	let user = userStore[userID];

    	if(user.attribute("username")===username){
    		callback(user);
    		break;
    	}
    }
}

app.initializers.add('ziven-shop', () => {
  	app.store.models.decorationStoreList = DecorationStore;
  	app.store.models.decorationStorePurchase = DecorationStorePurchase;
  	app.store.models.decorationStoreEquipment = DecorationStoreEquipment;
  	app.notificationComponents.decorationStorePurchase = DecorationStoreSubscriptionNotification;
  	
	app.routes['decorationStore'] = {
	    path: '/decorationStore',
	    component: DecorationStoreIndexPage,
	};

  	addSidebarMenu();
  	addUserPage();
  	// addShoppingCartMenu();

	extend(NotificationGrid.prototype, "notificationTypes", function (items) {
		items.add("decorationStorePurchase", {
		  name: "decorationStorePurchase",
		  icon: "fas fa-store",
		  label: app.translator.trans(
		    "ziven-decoration-store.forum.notification-receive-subscription"
		  ),
		});
	});

	if(FlagList){
		extend(FlagList.prototype, "view", function (vnode) {
	        let flagContentList = vnode.children.find(matchClass("NotificationList-content"))
	        .children.find(matchClass("NotificationGroup-content")).children;

	        if(flagContentList){
	        	for(let index in flagContentList){
	        		let flagContent = flagContentList[index];

	        		if(flagContent){
	        			if(flagContent.children){
	        				let flagContentChild = flagContent.children;
	        				if(flagContentChild[0]!==null){
				        		let avatarEle = flagContentChild[0].children.find(matchClass("Avatar"));
						        let usernameEle = flagContentChild[0].children.find(matchClass("Notification-content")).children.find(matchClass("username"));
						        let username = usernameEle.text;

				        		findUserInStore(username,function(user){
									attachAvatarFrame(avatarEle, user, "flag");
									attachUsernameColor(usernameEle, user, "flag");
						        });
	        				}
	        			}
	        		}
	        	}
	        }
		});
	}

	extend(Search.prototype, "view", function (vnode) {
        let searchResult = vnode.children.find(matchClass("Dropdown-menu Search-results"));

        if(searchResult){
        	let searchHeader = searchResult.children[1];

        	if(searchHeader){
        		for(let index in searchHeader.children){
        			let searchHeaderChild = searchHeader.children[index];
        			if(searchHeaderChild.attrs.className==="UserSearchResult"){
						let UserSearchResult = searchHeaderChild;
				        let avatarEle = UserSearchResult.children[0].children.find(matchClass('Avatar'));
				        let usernameEle = UserSearchResult.children[0].children.find(matchClass('username'));
				        let username = (usernameEle.children[0].children).replaceAll("<mark>","").replaceAll("</mark>","");
				        
				        findUserInStore(username,function(user){
							attachAvatarFrame(avatarEle, user, "search");
							attachUsernameColor(usernameEle, user, "search");
				        });
        			}
        		}
        	}
        }
	});

	// extend(Search.prototype, "onupdate", function (vnode) {
	// 	$(".decorationAvatarFrame_search").remove();
	// });

    extend(PostUser.prototype, 'view', function (vnode) {
        const user = this.attrs.post.user();

        if (!user) { return; }

        let avatarEle = vnode.children.find(matchTag('h3'))
            .children.find(matchTag(Link))
            .children.find(matchClass('Avatar PostUser-avatar'));

        attachAvatarFrame(avatarEle, user, "post");

        let usernameEle = vnode.children.find(matchTag('h3'))
            .children.find(matchTag(Link))
            .children.find(matchClass('username'));

        attachUsernameColor(usernameEle, user, "post");

    });

    extend(UserCard.prototype, 'view', function (vnode) {
        const identity = vnode.children.find(matchClass('darkenBackground'))
            .children.find(matchClass('container'))
            .children.find(matchClass('UserCard-profile'))
            .children.find(matchClass('UserCard-identity'));

        // This component will only exist if we are not in edit mode
        if (identity.children[0].tag === Link) {
            let avatarEle = identity.children[0]
                .children.find(matchClass('UserCard-avatar'))
                .children.find(matchClass('Avatar'));

            attachAvatarFrame(avatarEle, this.attrs.user,"userCard");
        }

		attachProfileBackground(vnode, this.attrs.user,"userCard");

		let usernameEle = identity.children.find(matchClass('username'));
		if(usernameEle===undefined){
        	if (identity.children[0].tag === Link) {
        		usernameEle = identity.children[0]
                .children.find(matchClass('username'));
        	}
		}

        attachUsernameColor(usernameEle, this.attrs.user, "userCard");
    });

    extend(AvatarEditor.prototype, 'view', function (vnode) {
        let avatarEle = vnode.children.find(matchClass('Avatar'));
        attachAvatarFrame(avatarEle, this.attrs.user,"avatarEditor");
    });

    extend(DiscussionList.prototype, 'view', function(vnode) {
    	if(vnode.children.length>1){
    		let discussionNode = vnode.children.find(matchTag('ul'));
	        let discussionList = discussionNode.children[discussionNode.children.length-1];

	        if(discussionList){
				let task = setInterval(function(){
					if(discussionList.dom){
						clearInterval(task);
						let discussionListChildren = discussionList.children;

						for(let a=0;a<discussionListChildren.length;a++){
							let discussionData = discussionListChildren[a].children[0].attrs.discussion;

							if(discussionData.attribute("isAnonymousMe")!==true){
								console.log(discussionData);
								if(discussionData.data.relationships.user){
									let discussionUserID = discussionData.data.relationships.user.data.id;
									let disussionUserData = app.store.getById('users', discussionUserID);

									insertAvatarFrame(discussionListChildren[a].children[0],disussionUserData,"discussionList");
								}
							}
						}
					}
				},checkTime);
	        }
    	}
    });

    extend(DiscussionComposer.prototype, 'view', function(vnode) {
        let avatarEle = vnode.children.find(matchTag('div')).children.find(matchClass('Avatar ComposerBody-avatar'));
        attachAvatarFrame(avatarEle, this.attrs.user,"discussionComposer");
    });

    extend(ReplyComposer.prototype, 'view', function(vnode) {
        let avatarEle = vnode.children.find(matchTag('div')).children.find(matchClass('Avatar ComposerBody-avatar'));
        attachAvatarFrame(avatarEle, this.attrs.user,"discussionComposer");
    });

    extend(EditPostComposer.prototype, 'view', function(vnode) {
        let avatarEle = vnode.children.find(matchTag('div')).children.find(matchClass('Avatar ComposerBody-avatar'));
        attachAvatarFrame(avatarEle, this.attrs.user,"discussionComposer");
    });

    extend(PostStream.prototype, 'view', function(vnode) {
	    let postReply = vnode.children.find(matchKey('reply'));

        if(postReply){
			let task = setInterval(function(){
				if(postReply.dom){
					clearInterval(task);
					$(".PostUser-badges").css("zIndex",20);
					insertAvatarFrame(postReply,app.session.user,"postStreamReply");
				}
			},checkTime);
        }
    });

	extend(HeaderSecondary.prototype, 'view', function (vnode) {
		if(app.session.user){
	        let itemSession = vnode.children.find(matchClass('item-session'));

	        if(itemSession){
				let task = setInterval(function(){
					if(itemSession.dom){
						clearInterval(task);
						insertAvatarFrame(itemSession,app.session.user,"headerSecondary");
					}
				},checkTime);
	        }
		}
	});

	extend(Notification.prototype, 'view', function (vnode) {
		let fromUserID = this.attrs.notification.data.relationships.fromUser.data.id;
		let fromUserData = app.store.getById('users', fromUserID);
        let avatarEle = vnode.children.find(matchClass('Avatar'));

        attachAvatarFrame(avatarEle, fromUserData,"notification");

		let NotificationContent = vnode.children.find(matchClass("Notification-title"))
			.children.find(matchClass("Notification-content"));

		if(NotificationContent.children!==undefined){
			let usernameEle = NotificationContent.children.find(matchClass("username"));

			if(usernameEle!==undefined){
        		attachUsernameColor(usernameEle, fromUserData, "notification");
			}
		}
	});
});

function attachComposerFullScreenEvent(from){
	if($(".item-fullScreen").hasClass("decorationStoreComposerBound")){
		return;
	}

	$(".item-fullScreen").addClass("decorationStoreComposerBound");

	$(".item-fullScreen").on('click', function () {
		$(".decorationAvatarFrame_"+from).hide();

		let task = setInterval(function(){
			if($(".item-exitFullScreen").length>0){
				clearInterval(task);
	    		attachComposerExitFullScreenEvent(from);
			}
		},checkTime);
	});

	$(".item-minimize").on('click', function () {
		$(".decorationAvatarFrame_"+from).hide();
		attachComposerExitMinimize(from);
	});
}

function attachComposerExitMinimize(from){
	if($(".Composer-content").hasClass("decorationStoreComposerBound")){
		return;
	}

	$(".Composer-content").addClass("decorationStoreComposerBound");

	$(".Composer-content").on('click', function () {
		if($(".item-fullScreen").length===0){
			$(".decorationAvatarFrame_"+from).show();

			let task = setInterval(function(){
				if($(".item-fullScreen").length>0){
					clearInterval(task);
		    		attachComposerFullScreenEvent(from);
				}
			},checkTime);
		}
	});
}

function attachComposerExitFullScreenEvent(from){
	if($(".item-exitFullScreen").hasClass("decorationStoreComposerBound")){
		return;
	}

	$(".item-exitFullScreen").addClass("decorationStoreComposerBound");
	$(".item-exitFullScreen").on('click', function () {
		$(".decorationAvatarFrame_"+from).show();

		let task = setInterval(function(){
			if($(".item-fullScreen").length>0){
				clearInterval(task);
	    		attachComposerFullScreenEvent(from);
			}
		},checkTime);
	});
}

String.prototype.replaceAll = function(find, replace) {
    let str = this;
    return str.replace(new RegExp(find, 'g'), replace);
};
